import sentry from '../../sentry';
import { Text, Flex, Button, Spinner } from '@chakra-ui/react';
import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { HttpContext } from '../../context/HttpContext';
import { usePlanToken } from '../../hooks/usePlanToken';
import { Link as RouterLink } from 'react-router-dom';

function VerifyingYourEmail() {
  const { confirmationToken } = useParams();
  const { publicAxios } = useContext(HttpContext);
  const [emailVerified, setEmailVerified] = useState(false);
  const [emailAlreadyVerified, setEmailAlreadyVerified] = useState(false);

  const { planToken } = usePlanToken();
  const loginPath = planToken ? `/login?planToken=${planToken}` : '/login';

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await publicAxios.post(`accounts/confirmation`, {
          token: confirmationToken,
        });

        if (response.data.account) {
          if (response.data.already_verified) {
            setEmailAlreadyVerified(true);
          }
          if (response.data.account.email_verified) {
            setEmailVerified(true);
          }
        }
      } catch (onError) {
        sentry.sendError(onError);
        console.log(onError);
      }
    };

    getData();
  }, []);

  return (
    <>
      {emailVerified ? (
        <Flex direction="column" alignItems="center" gap={4}>
          <Text textStyle="heading2" textAlign="center">
            Email verified!
          </Text>
          <Text textStyle="bodyMedium" textAlign="center">
            Your email has been successfully verified.
          </Text>
          <Button as={RouterLink} to={loginPath} mt={4}>
            Continue to login
          </Button>
        </Flex>
      ) : (
        <Flex direction="column" alignItems="center" gap={4}>
          <Text textStyle="heading2" textAlign="center">
            Verifying your email...
          </Text>
          <Text textStyle="bodyMedium" textAlign="center">
            Please be patient.
          </Text>
          <Spinner color="orangePrimary" size="lg" mt="20px" />
        </Flex>
      )}
    </>
  );
}

export default VerifyingYourEmail;
